import React from 'react';
import './header.css'

const Header = () => {
  return (
    <header>
       <div className="header__container">
          <h1 className="text">
              Pathfinding Algorithm Visualizer
          </h1>
       </div>
    </header>
  )
}

export default Header